import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import {
  FOSA_ROLES_ALLOWED,
  DEFAULT_FOSA_USER_PERMISSION,
} from "../utils/constant";

function RolePickers({ defaultValue, newValues, error }) {
  const roles = useSelector((state) => state.fosaReducer?.roles);
  const { t } = useTranslation();

  return (
    <div>
      <Typography color="#666666" sx={{ mb: 0.6 }}>
        {t("roleLabel")} *
      </Typography>

      {roles && (
        <Autocomplete
          size="small"
          multiple
          id="roles-pickers"
          options={roles.filter((role) =>
            FOSA_ROLES_ALLOWED.includes(role.name)
          )}
          getOptionLabel={(option) => option.name}
          defaultValue={defaultValue}
          onChange={(event, newValue) => {
            newValues(newValue);
          }}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField {...params} placeholder={t("rolePlaceholder")} />
          )}
        />
      )}

      {error && (
        <Typography variant="caption" color="red">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default RolePickers;
